import React from 'react';
import { RaisedButton } from 'material-ui';

const OptOutSuccess = props => {
  const data = [
    {
      text: 'Review',
      icon: require('../../../../www/images/quality-control.png'),
    },
    {
      text: 'Accept',
      icon: require('../../../../www/images/deal-agreement.png'),
    },
    {
      text: 'Load',
      icon: require('../../../../www/images/making-money.png'),
    },
    {
      text: 'Sell',
      icon: require('../../../../www/images/promotion.png'),
    },
  ];
  return (
    <div style={{ marginTop: '3em', width: '800px' }}>
      <div>Thank you for submitting your rates! your work is done. From here, we have a few things we need to do, so we can start selling your products. We'll let you know if we have any questions!</div>
      <div style={{ marginTop: '2em', border: '1px solid #e0e0e0', borderRadius: '3px', padding: '2em 4em' }}>
        <div style={{ fontWeight: 'bold' }}>What happens next?</div>
        <div style={{ marginTop: '2em' }} className="flex-tc-sb">
          {
            data.map(({ text, icon }, i) => (
              <div key={i}>
                <img src={icon} width={120} />
                <div style={{ marginTop: '16px', fontSize: '16px' }}>
                  {text}
                </div>
              </div>
            ))
          }
        </div>
      </div>
      <div style={{ fontWeight: 'bold', margin: '2em auto' }}>
        If you'd like to track or review your rates in the future...
      </div>
      <div style={{ width: '650px', margin: 'auto' }}>
        We store your rates on TourConnect so you can review them at any time. You can even send these rates to your other partners, adjusting commissions/nett rates/terms as needed.
      </div>
      <RaisedButton
        label="Sign up for a free account"
        primary
        style={{ margin: '2em auto' }}
        onClick={props.openSignUp}
      />
    </div>
  );
};

export default OptOutSuccess;



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/request/opt-out-success.jsx